import React, { useEffect, useState } from 'react';
import { sanitizeInfoHtml } from '../../helpers/sanitizeInfoHtml';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { guardarInfoPreguntas } from '../../actions/configFormularioAction';
import { esborrarErrorAction, esborrarOkAction } from '../../actions/ui';
import '../Evaluacion/InformacionPreguntas.css';

const CATEGORIAS = Array.from({ length: 9 }, (_, index) => index + 1);
const EMPTY_CATEGORIES = {};
const FASES = [
  { tipo: 'pregunta', key: 'preguntas', label: 'Indicadores' },
  { tipo: 'programa', key: 'programas', label: 'Programas' },
];
const HTML_FICHA = `<section class="indicador-card">
  <header class="capcalera">
    <span class="numero">INDICADOR 1.1</span>
    <h2>Títol de l'indicador</h2>
  </header>
  <div class="contingut">
    <h3>Descripció i justificació</h3>
    <p>Escriu aquí la descripció de l'indicador.</p>
    <h3>Font de dades</h3>
    <div class="font-dades"><strong>Font estadística:</strong><br><a href="https://example.org" target="_blank" rel="noopener noreferrer">Nom de la font ↗</a></div>
    <h3>Càlcul de l'indicador</h3>
    <p>Explica com es calcula l'indicador.</p>
    <div class="objectiu"><strong>Objectiu de referència</strong><p>Descriu l'objectiu.</p></div>
    <div class="formula"><small>Fórmula de càlcul</small><strong>P1.1 = ...</strong></div>
    <h3>Variables de càlcul</h3>
    <div class="variables">
      <div class="variable"><strong>P</strong><span>Descriu la variable.</span></div>
    </div>
  </div>
  <footer class="peu">Indicadors municipals · Nom de l'àmbit</footer>
</section>`;

export const InformacionPreguntasAdmin = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation('generic');
  const { auth, configFormulario, ui } = useSelector((state) => state);
  const configuracion = configFormulario.infoFormularioPreguntas?.categorias || EMPTY_CATEGORIES;
  const [categoriaAbierta, setCategoriaAbierta] = useState(null);
  const [tipo, setTipo] = useState('pregunta');
  const [preguntaAbierta, setPreguntaAbierta] = useState(null);
  const [vistaPreviaAbierta, setVistaPreviaAbierta] = useState(null);
  const [textosHtml, setTextosHtml] = useState({});
  const [textosCategoriasHtml, setTextosCategoriasHtml] = useState({});
  const [vistaPreviaCategoria, setVistaPreviaCategoria] = useState(null);

  useEffect(() => {
    const nuevosTextos = {};
    const nuevosTextosCategorias = {};
    CATEGORIAS.forEach((numero) => {
      const datosCategoria = configuracion[numero] || {};
      nuevosTextosCategorias[numero] = datosCategoria.infoHtml || '';
      FASES.forEach((fase) => {
        (datosCategoria[fase.key] || []).forEach((pregunta) => {
          nuevosTextos[pregunta.id] = pregunta.infoHtml || '';
        });
      });
    });
    setTextosHtml(nuevosTextos);
    setTextosCategoriasHtml(nuevosTextosCategorias);
  }, [configuracion]);

  useEffect(() => {
    if (!ui.msgError && !ui.msgOk) return undefined;
    const timeout = setTimeout(() => {
      dispatch(esborrarErrorAction());
      dispatch(esborrarOkAction());
    }, 8000);
    return () => clearTimeout(timeout);
  }, [dispatch, ui.msgError, ui.msgOk]);

  const todasLasPreguntas = CATEGORIAS.flatMap((numero) => {
    const datosCategoria = configuracion[numero] || {};
    return FASES.flatMap((item) => (datosCategoria[item.key] || []).map((pregunta) => ({
      ...pregunta,
      categoria: numero,
      tipo: item.tipo,
    })));
  });
  const cambios = todasLasPreguntas
    .filter((pregunta) => (textosHtml[pregunta.id] ?? '') !== (pregunta.infoHtml || ''))
    .map((pregunta) => ({
      categoria: pregunta.categoria,
      tipo: pregunta.tipo,
      orden: pregunta.orden,
      html: textosHtml[pregunta.id] ?? '',
    }));
  const cambiosCategorias = CATEGORIAS
    .filter((numero) => (textosCategoriasHtml[numero] ?? '') !== (configuracion[numero]?.infoHtml || ''))
    .map((numero) => ({
      categoria: numero,
      html: textosCategoriasHtml[numero] ?? '',
    }));

  const guardar = () => {
    if (cambios.length || cambiosCategorias.length) {
      dispatch(guardarInfoPreguntas(auth.tokenJwt, cambios, cambiosCategorias));
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <p className="ca-label-super">Administración</p>
        <h2 className="ca-h2">Información de los Indicadores
        </h2>
        <p className="ca-subtext">Contenido HTML opcional para cada conjunto, pregunta o programa.</p>
      </div>

      {ui.msgError && <div className="ms-alert-error" role="alert">{ui.msgError}</div>}
      {ui.msgOk && <div className="ms-alert-success" role="status">{ui.msgOk}</div>}

      {configFormulario.infoFormularioPreguntas == null ? (
        <p role="status">Cargando preguntas...</p>
      ) : (
        <div style={{ display:'grid', gap:8 }}>
          {CATEGORIAS.map((numeroCategoria) => {
            const abierta = categoriaAbierta === numeroCategoria;
            const preguntas = configuracion[numeroCategoria]?.[tipo === 'pregunta' ? 'preguntas' : 'programas'] || [];
            return (
              <section key={numeroCategoria} style={{ border:'1px solid #e5e7eb', borderRadius:6, overflow:'hidden', background:'#fff' }}>
                <button
                  type="button"
                  aria-expanded={abierta}
                  onClick={() => {
                    setCategoriaAbierta(abierta ? null : numeroCategoria);
                    setPreguntaAbierta(null);
                    setVistaPreviaAbierta(null);
                  }}
                  style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, padding:'13px 16px', border:0, background:abierta ? '#f8fafc' : '#fff', color:'#1f2937', textAlign:'left', cursor:'pointer' }}
                >
                  <span style={{ display:'flex', alignItems:'center', gap:10, minWidth:0 }}>
                    <span style={{ width:26, height:26, flex:'0 0 26px', display:'grid', placeItems:'center', borderRadius:4, background:abierta ? '#111827' : '#f1f5f9', color:abierta ? '#fff' : '#475569', fontSize:12, fontWeight:700 }}>{numeroCategoria}</span>
                    <span style={{ fontSize:14, lineHeight:1.45, fontWeight:600 }}>{t(`formulario.titleCat${numeroCategoria}`)}</span>
                  </span>
                  <span aria-hidden="true" style={{ fontSize:18, color:'#64748b', transform:abierta ? 'rotate(180deg)' : 'none' }}>⌄</span>
                </button>

                {abierta && (
                  <div style={{ padding:16, borderTop:'1px solid #e5e7eb' }}>
                    <section style={{ marginBottom:16, padding:14, border:'1px solid #e5e7eb', borderRadius:6, background:'#f9fafb' }}>
                      <label htmlFor={`info-categoria-${numeroCategoria}`} style={{ display:'block', marginBottom:6, fontSize:12, fontWeight:700, color:'#4b5563' }}>
                        Información del conjunto (HTML)
                      </label>
                      <textarea
                        id={`info-categoria-${numeroCategoria}`}
                        value={textosCategoriasHtml[numeroCategoria] ?? ''}
                        onChange={(event) => setTextosCategoriasHtml((actuales) => ({ ...actuales, [numeroCategoria]: event.target.value }))}
                        rows={5}
                        placeholder="<p>Escribe aquí la información general del conjunto...</p>"
                        className="fa-nivel-textarea"
                        style={{ width:'100%', boxSizing:'border-box', fontFamily:'monospace' }}
                      />
                      <div style={{ marginTop:10 }}>
                        <button
                          type="button"
                          aria-expanded={vistaPreviaCategoria === numeroCategoria}
                          onClick={() => setVistaPreviaCategoria(vistaPreviaCategoria === numeroCategoria ? null : numeroCategoria)}
                          style={{ padding:0, border:0, background:'transparent', color:'#334155', fontSize:12, fontWeight:700, cursor:'pointer' }}
                        >{vistaPreviaCategoria === numeroCategoria ? 'Ocultar vista previa' : 'Mostrar vista previa'}</button>
                        {vistaPreviaCategoria === numeroCategoria && (
                          <div style={{ marginTop:8, padding:12, border:'1px solid #e5e7eb', borderRadius:4, background:'#fff', overflowWrap:'anywhere' }}>
                            {textosCategoriasHtml[numeroCategoria]?.trim() ? (
                              <div className="info-pregunta-content" dangerouslySetInnerHTML={{ __html: sanitizeInfoHtml(textosCategoriasHtml[numeroCategoria]) }} />
                            ) : (
                              <span style={{ color:'#9ca3af', fontSize:13 }}>Sin información adicional</span>
                            )}
                          </div>
                        )}
                      </div>
                    </section>
                    <div role="tablist" aria-label={`Fase del formulario, categoría ${numeroCategoria}`} style={{ display:'flex', gap:4, padding:4, marginBottom:12, background:'#f3f4f6', borderRadius:6, width:'fit-content' }}>
                      {FASES.map((fase) => (
                        <button
                          key={fase.tipo}
                          type="button"
                          role="tab"
                          aria-selected={tipo === fase.tipo}
                          onClick={() => { setTipo(fase.tipo); setPreguntaAbierta(null); setVistaPreviaAbierta(null); }}
                          style={{ border:0, borderRadius:4, padding:'8px 14px', background:tipo === fase.tipo ? '#fff' : 'transparent', color:tipo === fase.tipo ? '#111827' : '#6b7280', fontWeight:700, cursor:'pointer' }}
                        >{fase.label}</button>
                      ))}
                    </div>

                    {preguntas.length === 0 ? <p>No hay preguntas configuradas en esta fase.</p> : (
                      <div style={{ display:'grid', gap:8 }}>
                        {preguntas.map((pregunta, index) => {
                          const html = textosHtml[pregunta.id] ?? '';
                          const preguntaAbiertaActual = preguntaAbierta === pregunta.id;
                          const vistaPrevia = vistaPreviaAbierta === pregunta.id;
                          return (
                            <section key={pregunta.id} style={{ border:'1px solid #e5e7eb', borderRadius:6, overflow:'hidden', background:'#fff' }}>
                              <button
                                type="button"
                                aria-expanded={preguntaAbiertaActual}
                                onClick={() => {
                                  setPreguntaAbierta(preguntaAbiertaActual ? null : pregunta.id);
                                  setVistaPreviaAbierta(null);
                                }}
                                style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, padding:'13px 16px', border:0, background:preguntaAbiertaActual ? '#f8fafc' : '#fff', color:'#1f2937', textAlign:'left', cursor:'pointer' }}
                              >
                                <span style={{ display:'flex', alignItems:'center', gap:10, minWidth:0 }}>
                                  <span style={{ width:26, height:26, flex:'0 0 26px', display:'grid', placeItems:'center', borderRadius:4, background:'#f1f5f9', color:'#475569', fontSize:12, fontWeight:700 }}>{index + 1}</span>
                                  <span style={{ fontSize:14, lineHeight:1.45, fontWeight:600 }}>{pregunta.label}</span>
                                </span>
                                <span aria-hidden="true" style={{ fontSize:18, color:'#64748b', transform:preguntaAbiertaActual ? 'rotate(180deg)' : 'none' }}>⌄</span>
                              </button>

                              {preguntaAbiertaActual && (
                                <div style={{ padding:16, borderTop:'1px solid #e5e7eb' }}>
                                  <label htmlFor={`info-html-${pregunta.id}`} style={{ display:'block', marginBottom:6, fontSize:12, fontWeight:700, color:'#4b5563' }}>
                                    Contenido HTML
                                  </label>
                                  <textarea
                                    id={`info-html-${pregunta.id}`}
                                    value={html}
                                    onChange={(event) => setTextosHtml((actuales) => ({ ...actuales, [pregunta.id]: event.target.value }))}
                                    rows={5}
                                    placeholder="<p>Escribe aquí la información de ayuda...</p>"
                                    className="fa-nivel-textarea"
                                    style={{ width:'100%', boxSizing:'border-box', fontFamily:'monospace' }}
                                  />
                                  {!html.trim() && (
                                    <button
                                      type="button"
                                      onClick={() => setTextosHtml((actuales) => ({ ...actuales, [pregunta.id]: HTML_FICHA }))}
                                      style={{ marginTop:8, padding:'7px 10px', border:'1px solid #cbd5e1', borderRadius:4, background:'#fff', color:'#334155', fontSize:12, cursor:'pointer' }}
                                    >Insertar plantilla de ficha</button>
                                  )}
                                  <div style={{ marginTop:12 }}>
                                    <button
                                      type="button"
                                      aria-expanded={vistaPrevia}
                                      onClick={() => setVistaPreviaAbierta(vistaPrevia ? null : pregunta.id)}
                                      style={{ padding:0, border:0, background:'transparent', color:'#334155', fontSize:12, fontWeight:700, cursor:'pointer' }}
                                    >{vistaPrevia ? 'Ocultar vista previa' : 'Mostrar vista previa'}</button>
                                    {vistaPrevia && (
                                      <div style={{ marginTop:8, padding:12, border:'1px solid #e5e7eb', borderRadius:4, background:'#f9fafb', overflowWrap:'anywhere' }}>
                                        {html.trim() ? (
                                          <div className="info-pregunta-content" dangerouslySetInnerHTML={{ __html: sanitizeInfoHtml(html) }} />
                                        ) : (
                                          <span style={{ color:'#9ca3af', fontSize:13 }}>Sin información adicional</span>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </section>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </section>
            );
          })}
        </div>
      )}

      <div style={{ marginTop:20, display:'flex', justifyContent:'flex-end' }}>
        <button type="button" className="u-btn-primary" onClick={guardar} disabled={!cambios.length && !cambiosCategorias.length}>
          Guardar información{cambios.length + cambiosCategorias.length ? ` (${cambios.length + cambiosCategorias.length})` : ''}
        </button>
      </div>
    </div>
  );
};